import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { api } from '../../../../../services';

import { Form, Input, Spin } from 'antd';
import AirModalTitlebar from '../../../../../common/components/AirModalTitlebar';
import AirButton from '../../../../../common/components/AirButton';

import { withRouter } from 'react-router-dom';

import './ChangePasswordModal.css';

@withRouter
@inject('translationsStore', 'authStore')
@observer
class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      visibleChangePasswordModal: true,
      done: false,
      visible: this.props.visible
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.handleUpdate();
  };

  onOk = () => {
    if (!this.state.done) {
      this.handleUpdate();
    } else {
      this.onCancel();
    }
  };

  handleUpdate = () => {
    const { authStore } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        api('changePassword', authStore.user, values.oldpassword, values.newpassword)
          .then(() => {
            this.setState({ loading: false, done: true });
          })
          .catch(error => {
            this.setState({ loading: false, message: error.message });
          });
      }
    });
  };

  onCancel = e => {
    this.props.onCancel(e);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { translationsStore } = this.props;
    return (
      <AirModalTitlebar
        className="ChangePasswordModal"
        visible={this.props.visible}
        okButton={
          <AirButton
            size="large"
            light
            label={!this.state.done ? translationsStore.translate('changepassword.modal.labelEdit') : translationsStore.translate('changepassword.modal.labelDismiss')}
          />
        }
        onOk={this.onOk}
        onCancel={this.onCancel}
        title={translationsStore.translate('changepassword.modal.title')}
        width="560"
      >
        <div style={{ padding: '40px 40px 0px' }}>
          <Spin spinning={this.state.loading}>
            {!this.state.done ? (
              <Form onSubmit={this.handleSubmit} className="ChangePasswordModalForm">
                <Form.Item>
                  {getFieldDecorator('oldpassword', {
                    rules: [
                      {
                        required: true,
                        message: translationsStore.translate('changepassword.modal.checkOldPassword')
                      }
                    ]
                  })(<Input type="password" placeholder={translationsStore.translate('changepassword.modal.placeholderOldPassword')} />)}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator('newpassword', {
                    rules: [
                      {
                        required: true,
                        message: translationsStore.translate('changepassword.modal.checkNewPassword')
                      }
                    ]
                  })(<Input type="password" placeholder={translationsStore.translate('changepassword.modal.placeholderNewPassword')} />)}
                </Form.Item>
                <div style={{ color: 'red' }}>{this.state.message}</div>
              </Form>
            ) : (
              <div style={{ color: 'var(--bg-color-2)', fontSize: 14, width: 560 }}>{translationsStore.translate('changepassword.modal.success')}</div>
            )}
          </Spin>
        </div>
      </AirModalTitlebar>
    );
  }
}

export default Form.create()(ChangePasswordModal);



// WEBPACK FOOTER //
// ./src/components/App/Profile/UserInformation/ChangePasswordModal/ChangePasswordModal.js